<template>
  <div class="customer-contract-preview-container">
    <el-alert
      v-if="error"
      :title="error"
      type="error"
      :closable="false"
      show-icon>
    </el-alert>

    <div v-if="loading" class="loading-container">
      <el-skeleton animated :rows="10" />
    </div>
    
    <div v-else class="contract-content">
    <!-- 顶部导航栏 -->
      <div class="top-nav" v-if="false">
        <div class="company-info">{{ contractInfo.customer_name }}</div>
        <div class="contract-info">{{ contractInfo.title }}</div>
    </div>
    
    <!-- 合同标题 -->
      <h2 class="contract-title">{{ contractInfo.title }}</h2>
    
    <!-- 合同清单标题 -->
    <div class="section-title">
        <h3>合同清单</h3>
      <div class="divider"></div>
    </div>
    
    <!-- 合同商品明细表格 -->
    <el-table
        :data="contractItems"
      border
      style="width: 100%"
      :header-cell-style="{ background: '#f5f7fa', color: '#333', fontWeight: 'normal' }"
    >
      <el-table-column prop="category" label="分类" width="80" align="center"></el-table-column>
      <el-table-column prop="index" label="序号" width="60" align="center"></el-table-column>
        <el-table-column prop="material_name" label="材料名称" min-width="150" align="center"></el-table-column>
        <el-table-column prop="spec_model" label="规格型号" min-width="180" align="center"></el-table-column>
      <el-table-column prop="unit" label="单位" width="70" align="center"></el-table-column>
      <el-table-column prop="quantity" label="数量" width="90" align="center"></el-table-column>
        <el-table-column prop="unit_price" label="税前单价（元）" width="130" align="center"></el-table-column>
      <el-table-column prop="tax_rate" label="税率" width="80" align="center">
        <template slot-scope="scope">
          {{ formatTaxRate(scope.row.tax_rate) }}
        </template>
      </el-table-column>
        <el-table-column prop="tax_price" label="含税单价（元）" width="130" align="center"></el-table-column>
    </el-table>
    
    <!-- 基本信息标题 -->
    <div class="section-title">
      <h3>基本信息</h3>
      <div class="divider"></div>
    </div>
    
    <!-- 基本信息内容 -->
    <div class="info-container">
      <el-row :gutter="0" class="info-row">
        <el-col :span="6" class="info-label">
          <div class="label-container">客户名称</div>
        </el-col>
        <el-col :span="18" class="info-value">
          <div class="value-container">{{ contractInfo.customer_name }}</div>
        </el-col>
      </el-row>
      
      <el-row :gutter="0" class="info-row">
          <el-col :span="4" class="info-label">
          <div class="label-container">交货时间</div>
        </el-col>
          <el-col :span="8" class="info-value">
          <div class="value-container">{{ contractInfo.delivery_time }}</div>
        </el-col>
          <el-col :span="4" class="info-label">
          <div class="label-container">计价方式</div>
        </el-col>
          <el-col :span="8" class="info-value">
            <div class="value-container">{{ contractInfo.pricing_method }}</div>
        </el-col>
      </el-row>
      
      <el-row :gutter="0" class="info-row">
          <el-col :span="4" class="info-label">
          <div class="label-container">结算时间</div>
        </el-col>
          <el-col :span="8" class="info-value">
            <div class="value-container">{{ contractInfo.settlement_method }}</div>
        </el-col>
          <el-col :span="4" class="info-label">
            <div class="label-container">付款方式</div>
        </el-col>
          <el-col :span="8" class="info-value">
            <div class="value-container">{{ contractInfo.payment_method }}</div>
        </el-col>
      </el-row>
      
      <el-row :gutter="0" class="info-row">
          <el-col :span="4" class="info-label">
            <div class="label-container">是否计息</div>
        </el-col>
          <el-col :span="8" class="info-value">
            <div class="value-container">{{ contractInfo.is_interest }}</div>
        </el-col>
      </el-row>
      
      <el-row :gutter="0" class="info-row">
          <el-col :span="4" class="info-label">
            <div class="label-container">计息条件</div>
        </el-col>
          <el-col :span="20" class="info-value">
            <div class="value-container">{{ contractInfo.interest_conditions }}</div>
        </el-col>
      </el-row>
      </div>
    </div>
    
    <!-- 底部操作按钮 -->
    <div class="action-buttons">
      <el-button 
        v-if="contractStatus === 'ACTIVE' && !isCreator"
        @click="confirmContract" 
        type="success">确认合同</el-button>
      <el-button @click="goBack" type="primary">返回</el-button>
      <el-button v-permission="'contracts:contract-view:print'" @click="printContract" type="primary" plain>打印</el-button>
    </div>
  </div>
</template>

<script>
import { getContractById, updateContractStatus } from '@/api/modules/contracts.js';
import { getUserInfo } from '@/utils/auth.js';
import { installPlatformPrintFooter } from '@/utils/print-footer';

export default {
  name: 'CustomerContractPreview',
  data() {
    return {
      contractId: null,
      contractInfo: {
        title: '',
        customer_name: '',
        supplier_name: '',
        customerProject: '',
        delivery_time: '',
        payment_method: '',
        settlement_method: '',
        interest_conditions: '',
        pricing_method: '',
        is_interest: '',
        total_amount: '',
        remark: '',
        confirmed: false
      },
      productList: [],
      contractItems: [],
      loading: false,
      error: null,
      contractStatus: '',
      currentUser: null,
      contractCreatorId: null,
      isCreator: false
    };
  },
  created() {
    // 获取当前用户信息
    this.currentUser = getUserInfo();
// 获取路由参数中的合同ID
    this.contractId = this.$route.params.id;
    if (this.contractId) {
      this.fetchContractData(this.contractId);
    } else {
      this.error = '合同ID不存在，无法获取合同详情';
    }
  },
  methods: {
    // 获取合同详情
    fetchContractData(id) {
      if (!id) {
        this.error = '合同ID不存在，无法获取合同详情';
        return;
      }
      
      // 对于新建的合同，使用特殊处理
      if (id === 'new') {
        this.error = '新建合同尚未保存，无法预览详情';
        this.loading = false;
        return;
      }
      
      this.loading = true;
      this.error = null;
      
      getContractById(id)
        .then(response => {
          
          if (response.data && response.data.success) {
            const contractData = response.data.data;
            
            try {
              // 获取客户信息 - 从contractParties中获取CUSTOMER类型的数据
              const customerParty = contractData.contractParties?.find(party => party.partyType === 'CUSTOMER');
              const customerName = customerParty?.unitInfo?.unitName || '';
              
              // 获取供应商信息 - 从创建者信息中获取
              const supplierName = contractData.creatorName || '';
              
              // 格式化付款方式
              const formatPaymentMethod = () => {
                const days70 = contractData.payment70PercentDays || 30;
                const daysFull = contractData.paymentFullDays || 90;
                return `货到${days70}天内付70%，${daysFull}天内付清余款`;
              };
              
              // 格式化计息条件
              const formatInterestConditions = () => {
                if (!contractData.interestCalculation) {
                  return '不计息';
                }
                
                const freeDays = contractData.interestFreeDays || 0;
                const rateType = contractData.interestRateType;
                const fixedRate = contractData.fixedInterestRate || 0;
                
                let conditions = `免息期${freeDays}天`;
                if (rateType === 'FIXED' && fixedRate > 0) {
                  conditions += `，超期按${fixedRate}%年利率计息`;
                }
                
                return conditions;
              };
              
              // 映射定价方式
              const mapPricingMethod = (method) => {
                const mapping = {
                  'FIXED': '固定价格',
                  'VARIABLE': '变动价格',
                  'MARKET': '市场价格'
                };
                return mapping[method] || method || '固定价格';
              };
              
              // 设置合同基本信息
              this.contractInfo = {
                title: contractData.contractName || '销售合同',
                customer_name: customerName,
                supplier_name: supplierName,
                customerProject: customerName,
                delivery_time: contractData.contractDate ? new Date(contractData.contractDate).toLocaleDateString() : '',
                payment_method: formatPaymentMethod(),
                settlement_method: contractData.settlementMethod || '每月20日结算',
                interest_conditions: formatInterestConditions(),
                pricing_method: mapPricingMethod(contractData.pricingMethod),
                is_interest: contractData.interestCalculation ? '是' : '否',
                total_amount: contractData.contractAmount ? `${contractData.contractAmount}元` : '框架合同，具体金额以实际供货量为准',
                remark: '',
                confirmed: contractData.status === 'EXECUTING'
              };
              
              // 设置合同状态和创建者信息
              this.contractStatus = contractData.status || '';
              this.contractCreatorId = contractData.creatorId;
              
              // 判断当前用户是否为合同创建者
              if (this.currentUser && this.contractCreatorId) {
                this.isCreator = this.currentUser.id === this.contractCreatorId;
              }
              
              // 客户名称已在上面设置，无需额外处理
              
              // 设置商品列表 - 使用新API结构中的contractItems
              if (contractData.contractItems && Array.isArray(contractData.contractItems)) {
                this.contractItems = contractData.contractItems.map((item, index) => {
                  // 计算含税单价
                  const unitPrice = item.unitPrice || 0;
                  const taxRate = item.taxRate || 0;
                  const taxPrice = unitPrice * (1 + taxRate / 100);
                  
                  return {
                    category: item.remark || '未分类',
                    index: index + 1,
                    material_name: item.productName || '',
                    spec_model: item.specification || '',
                    unit: item.unit || '',
                    quantity: item.quantity || 0,
                    unit_price: unitPrice.toFixed(2),
                    tax_rate: taxRate,
                    tax_price: taxPrice.toFixed(2)
                  };
                });
              } else {
                this.contractItems = [];
              }
            } catch (err) {
              this.error = '处理合同数据时出错: ' + err.message;
            }
          } else {
            this.error = response.data?.message || '获取合同数据失败';
          }
          
          this.loading = false;
        })
        .catch(error => {
          this.error = '获取合同数据出错: ' + (error.response?.data?.message || error.message || '未知错误');
          this.loading = false;
        });
    },
    

    
    // 返回上一页
    goBack() {
      this.$router.go(-1);
    },
    
    // 打印合同
    async printContract() {
      // 创建一个新窗口用于打印
      const printWindow = window.open('', '_blank');
      if (!printWindow) {
        this.$message.error('打印窗口被阻止，请允许弹出窗口');
        return;
      }
      
      // 获取当前合同内容
      const contractContent = document.querySelector('.customer-contract-preview-container .contract-content');
      if (!contractContent) {
        this.$message.error('未找到合同内容');
        return;
      }
      
      // 获取合同内容的HTML
      const contentHTML = contractContent.innerHTML;
      
      // 写入打印窗口基本HTML结构
      printWindow.document.open();
      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>${this.contractInfo.title || '客户合同'}</title>
          <meta charset="utf-8">
          <style>
            body {
              font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", Arial, sans-serif;
              color: #333;
              line-height: 1.5;
              padding: 20px;
              margin: 0;
            }
            
            .contract-title {
              text-align: center;
              font-size: 22px;
              font-weight: 500;
              margin: 20px 0 30px;
            }
            
            .section-title {
              border-bottom: 2px solid #000;
              margin: 30px 0 15px;
            }
            
            .section-title h3 {
              font-size: 16px;
              font-weight: 500;
              margin: 0 0 5px 0;
            }
            
            table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 30px;
            }
            
            th, td {
              border: 1px solid #000;
              padding: 8px;
              text-align: center;
            }
            
            th {
              background-color: #f5f7fa;
              font-weight: 500;
            }
            
            .info-row {
              display: flex;
              width: 100%;
              border: 1px solid #000;
              border-bottom: none;
            }
            
            .info-row:last-child {
              border-bottom: 1px solid #000;
            }
            
            .info-label {
              width: 16.67%;
              background-color: #f5f7fa;
              padding: 12px 15px;
              border-right: 1px solid #000;
              font-weight: 500;
            }
            
            .info-value {
              width: 83.33%;
              padding: 12px 15px;
            }
            
            .half-width {
              width: 33.33%;
            }
            
            @page {
              size: A4 portrait;
              margin: 1cm;
            }
            
            .print-controls {
              text-align: center;
              margin: 20px 0;
              padding: 10px;
              background-color: #f5f7fa;
              border-radius: 4px;
            }
            
            .print-controls button {
              padding: 6px 16px;
              background-color: #409EFF;
              color: white;
              border: none;
              border-radius: 4px;
              cursor: pointer;
              margin: 0 5px;
              font-size: 14px;
            }
            
            .print-controls button:hover {
              background-color: #66b1ff;
            }
            
            .print-controls .close-btn {
              background-color: #909399;
            }
            
            .print-note {
              font-size: 12px;
              color: #606266;
              margin-top: 5px;
            }
            
            @media print {
              .print-controls {
                display: none;
              }
            }
          </style>
        </head>
        <body>
          <div class="print-controls">
            <button onclick="doPrint()">打印</button>
            <button class="close-btn" onclick="window.close()">关闭窗口</button>
            <div class="print-note">打印完成后窗口将在60秒后自动关闭，或点击"关闭窗口"按钮手动关闭</div>
          </div>
          
          <div id="contract-content"></div>
        </body>
        </html>
      `);
      
      await installPlatformPrintFooter(printWindow, null, {
        documentType: 'CONTRACT',
        documentKey: this.contractId
      });
      // 关闭文档流
      printWindow.document.close();
      
      // 在窗口加载完成后注入内容和处理打印
      printWindow.onload = function() {
        // 设置合同内容
        printWindow.document.getElementById('contract-content').innerHTML = contentHTML;
        
        // 添加脚本
        const script = printWindow.document.createElement('script');
        script.textContent = `
          function doPrint() {
            window.print();
          }
          
          // 页面加载完成自动打印
          window.addEventListener('load', function() {
            window.focus();
            
            // 延迟打印，确保内容已加载
            setTimeout(function() {
      window.print();
            }, 500);
            
            // 60秒后自动关闭窗口
            setTimeout(function() {
              window.close();
            }, 60000);
          });
          
          // 尝试监听打印完成事件
          if (window.matchMedia) {
            const mediaQueryList = window.matchMedia('print');
            mediaQueryList.addEventListener('change', function(mql) {
              if (!mql.matches) {
                // 打印对话框已关闭，5秒后关闭窗口
                setTimeout(function() {
                  window.close();
                }, 5000);
              }
            });
          }
        `;
        printWindow.document.body.appendChild(script);
      };
    },
    
    // 确认合同
    confirmContract() {
      this.$confirm('确认后合同状态将变为执行中，是否继续？', '确认合同', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 调用API更新合同状态
        updateContractStatus(this.contractId, 'EXECUTING')
          .then(response => {
            if (response.data && response.data.success) {
              this.$message.success('合同确认成功');
              // 更新本地状态
              this.contractStatus = 'EXECUTING';
              this.contractInfo.confirmed = true;
              // 跳转到合同列表页面
              this.$router.push('/contracts/customer-contracts-list');
            } else {
              this.$message.error(response.data?.message || '合同确认失败');
            }
          })
          .catch(error => {
            console.error('确认合同失败:', error);
            this.$message.error('确认合同失败: ' + (error.response?.data?.message || error.message || '未知错误'));
          });
      }).catch(() => {
        // 用户取消确认
      });
    },
    // 格式化税率显示（添加%符号）
    formatTaxRate(value) {
      if (value === null || value === undefined || value === '') return '0%';
      const num = parseFloat(value);
      if (isNaN(num)) return '0%';
      // 如果值小于1，说明是小数形式（如0.13），转换为百分比形式（13）
      if (num < 1 && num > 0) {
        return `${Math.round(num * 100)}%`;
      }
      // 如果值大于等于1，说明已经是百分比形式（如13），直接返回
      return `${Math.round(num)}%`;
    }
  }
};
</script>

<style lang="scss" scoped>
.customer-contract-preview-container {
  background-color: #fff;
  min-height: calc(100vh - 120px);
  
  .debug-panel {
    background-color: #fff8e1;
    border: 1px solid #ffecb3;
    padding: 15px;
    margin: 20px;
    border-radius: 4px;
    
    h3 {
      margin-top: 0;
      color: #ff9800;
    }
    
    p {
      margin: 5px 0;
      font-family: monospace;
      word-break: break-all;
      font-size: 14px;
    }
    
    .debug-actions {
      margin-top: 15px;
    }
  }
  
  .loading-container {
    margin: 20px;
    padding: 20px;
    background-color: #f5f7fa;
    border-radius: 4px;
  }
  
  .contract-content {
    padding: 40px 20px 0; /* 增加上边距，将内容往下移 */
    max-width: 1180px;
    margin: 0 auto;
  }
  
  .top-nav {
    background-color: #2c73eb;
    color: white;
    padding: 10px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 -20px 20px -20px;
    
    .company-info {
      font-size: 14px;
    }
    
    .contract-info {
      background-color: white;
      color: #2c73eb;
      padding: 8px 15px;
      border-radius: 4px;
      font-size: 14px;
    }
  }
  
  .contract-title {
    text-align: center;
    font-size: 22px;
    font-weight: 500;
    margin: 30px 0;
    color: #333;
  }
  
  .section-title {
    border-bottom: 2px solid #333;
    margin: 30px 0 15px;
    
    h3 {
      font-size: 16px;
      font-weight: 500;
      margin: 0 0 5px 0;
      color: #333;
    }
    
    .divider {
      display: none;
    }
  }
  
  .info-container {
    margin-bottom: 30px;
    border: none;
    
    .info-row {
      border: 1px solid #333;
      border-bottom: none;
      
      &:last-child {
        border-bottom: 1px solid #333;
      }
      
      .info-label {
        background-color: #f5f7fa;
        
        .label-container {
          padding: 12px 15px;
          color: #333;
          border-right: 1px solid #333;
          font-size: 14px;
        }
      }
      
      .info-value {
        .value-container {
          padding: 12px 15px;
          color: #333;
          font-size: 14px;
        }
      }
    }
  }
  
  .action-buttons {
    margin: 30px 20px;
    text-align: center;
    
    .el-button {
      min-width: 100px;
      margin: 0 10px;
    }
  }
  
  /* 表格样式 */
  >>> .el-table {
    width: 100% !important;
    margin: 0;
    
    th, td {
      border-color: #333;
      padding: 8px;
      text-align: center;
      font-size: 14px;
    }
    
    .el-table__header-wrapper th {
      background-color: #f5f7fa;
      color: #333;
      font-weight: 500;
    }
    
    .el-table__row {
      height: 40px;
    }
    
    .el-table__row:nth-child(even) {
      background-color: #fafafa;
    }
  }
  
  /* 打印样式 */
  @media print {
    .top-nav, .action-buttons, .debug-panel {
      display: none !important;
    }
    
    .info-container, .el-table {
      page-break-inside: avoid;
    }
    
    .customer-contract-preview-container {
      padding: 0 !important;
      margin: 0 !important;
      background-color: white !important;
    }
    
    ::-webkit-scrollbar {
      display: none !important;
    }
    
    .info-row, .info-label .label-container, .el-table th, .el-table td {
      border-color: #000 !important;
    }
    
    .section-title {
      border-bottom: 2px solid #000 !important;
    }
    
    >>> .el-table {
      border-color: #000 !important;
    }
  }
}
</style>
